import React, { useState } from 'react';
import HelperIcon from './HelperIcon';
import { helperContent } from '../content/helper-content';

const MatchResult = ({ match, rank }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Determine confidence level color
  const getConfidenceColor = (score) => {
    if (score >= 90) return 'confidence-high';
    if (score >= 75) return 'confidence-medium';
    return 'confidence-low';
  };

  const confidenceClass = getConfidenceColor(match.confidence_score);

  return (
    <div className={`match-result ${confidenceClass}`}>
      <div className="match-rank">#{rank}</div>

      <div className="match-header">
        <div className="tutor-avatar-container">
          {match.tutor_headshot ? (
            <img
              src={match.tutor_headshot}
              alt={match.tutor_name}
              className="tutor-avatar"
            />
          ) : (
            <div className="tutor-avatar-placeholder">
              <span>{match.tutor_name?.charAt(0)?.toUpperCase() || 'T'}</span>
            </div>
          )}
          <div className={`confidence-ring ${confidenceClass}`}></div>
        </div>

        <div className="tutor-info">
          <h3 className="tutor-name">{match.tutor_name}</h3>
          <div className="confidence-score">
            <div className="score-bar-container">
              <div
                className="score-bar-fill"
                style={{ width: `${match.confidence_score}%` }}
              ></div>
            </div>
            <span className="score-text">{match.confidence_score}% Match</span>
          </div>
        </div>
      </div>

      {match.tutor_bio && (
        <p className="tutor-bio">{match.tutor_bio.substring(0, 150)}{match.tutor_bio.length > 150 ? '...' : ''}</p>
      )}

      <button
        className="expand-button"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? '▼ Hide Details' : '► Why this match?'}
      </button>

      {isExpanded && (
        <div className="match-details">
          <div className="explanation">
            <div className="explanation-header">
              <h4>Match Explanation</h4>
              <HelperIcon
                title={helperContent.matchingRationale.title}
                content={helperContent.matchingRationale.content}
                size="small"
              />
            </div>
            <p>{match.explanation}</p>
          </div>

          {match.category_scores && (
            <div className="category-scores">
              <h4>Category Breakdown</h4>
              <div className="category-grid">
                <div className="category-item">
                  <span className="category-label">Subject Expertise</span>
                  <div className="category-bar">
                    <div
                      className="category-bar-fill"
                      style={{ width: `${match.category_scores.subject_expertise || 0}%` }}
                    ></div>
                  </div>
                  <span className="category-score">{match.category_scores.subject_expertise || 0}%</span>
                </div>

                <div className="category-item">
                  <span className="category-label">Learning Style</span>
                  <div className="category-bar">
                    <div
                      className="category-bar-fill"
                      style={{ width: `${match.category_scores.learning_style || 0}%` }}
                    ></div>
                  </div>
                  <span className="category-score">{match.category_scores.learning_style || 0}%</span>
                </div>

                <div className="category-item">
                  <span className="category-label">Session Preferences</span>
                  <div className="category-bar">
                    <div
                      className="category-bar-fill"
                      style={{ width: `${match.category_scores.session_preferences || 0}%` }}
                    ></div>
                  </div>
                  <span className="category-score">{match.category_scores.session_preferences || 0}%</span>
                </div>

                <div className="category-item">
                  <span className="category-label">Personality Fit</span>
                  <div className="category-bar">
                    <div
                      className="category-bar-fill"
                      style={{ width: `${match.category_scores.personality_fit || 0}%` }}
                    ></div>
                  </div>
                  <span className="category-score">{match.category_scores.personality_fit || 0}%</span>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MatchResult;
